import React from 'react';

interface TableSkeletonShellProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
  className?: string;
}

/**
 * Shared table skeleton used across list/table screens to keep loaders consistent.
 */
const TableSkeletonShell: React.FC<TableSkeletonShellProps> = ({
  rows = 6,
  columns = 6,
  showHeader = true,
  className = ''
}) => {
  const cellClass = 'px-3 md:px-4 py-3 md:py-4';

  return (
    <div
      className={`overflow-x-auto rounded-2xl shadow-sm border border-gray-200 bg-white ${className}`}
      role='status'
      aria-busy='true'
    >
      <table className='min-w-full text-sm'>
        {showHeader && (
          <thead className='bg-slate-50 sticky top-0 z-10'>
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th
                  key={index}
                  className={`${cellClass} font-semibold text-left text-slate-700`}
                >
                  <div className='h-4 w-20 bg-slate-200 rounded animate-pulse' />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className={`transition-colors ${
                rowIndex % 2 === 0 ? 'bg-white' : 'bg-slate-50'
              } hover:bg-blue-50`}
            >
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className={cellClass}>
                  <div className='h-4 w-full bg-slate-200 rounded animate-pulse' />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeletonShell;
